(() => {
  let menuOpener;
  function closeMenu(restore = true) {
    document.querySelectorAll('[data-main-nav].open').forEach(nav => {
      nav.classList.remove('open');
      const panel = nav.querySelector('[data-menu-panel]');
      panel.removeAttribute('role'); panel.removeAttribute('aria-modal'); panel.removeAttribute('aria-label');
    });
    document.querySelectorAll('[data-menu-toggle]').forEach(button => button.setAttribute('aria-expanded', 'false'));
    document.body.classList.remove('mobile-nav-open');
    if (restore && menuOpener?.isConnected) menuOpener.focus();
  }
  function init() {
    document.querySelectorAll('.watch-video video').forEach(video => {
      if (video.dataset.soundReady) return;
      video.dataset.soundReady = 'true';
      const button = video.parentElement.querySelector('[data-watch-sound]');
      const updateSound = () => {
        const audible = !video.muted && video.volume > 0;
        button.textContent = audible ? 'Mute' : 'Unmute';
        button.setAttribute('aria-label', audible ? 'Mute video' : 'Unmute video');
        button.setAttribute('aria-pressed', String(audible));
      };
      video.addEventListener('volumechange', updateSound);
      updateSound();
    });
    const header = document.querySelector('[data-header]');
    const panel = header?.querySelector('[data-search-panel]');
    if (panel) document.querySelectorAll('[data-search-content]').forEach(section => { if (!panel.contains(section)) { if (panel.querySelector('[data-header-search-content]')) section.hidden = true; else panel.append(section); } });
    document.querySelectorAll('[data-footer-links]').forEach(details => { details.open = matchMedia('(min-width:750px)').matches; });
  }
  function closeSearch() { document.querySelectorAll('[data-search-panel]').forEach(p => p.hidden = true); document.querySelectorAll('[data-search-input]').forEach(i => i.setAttribute('aria-expanded', 'false')); }
  document.addEventListener('focusin', event => { if (event.target.matches('[data-search-input]')) { const panel = document.querySelector('[data-search-panel]'); if (panel) { panel.hidden = false; event.target.setAttribute('aria-expanded', 'true'); } } });
  document.addEventListener('click', event => {
    const sound = event.target.closest('[data-watch-sound]');
    if (sound) {
      const video = sound.closest('.watch-video').querySelector('video');
      const audible = !video.muted && video.volume > 0;
      video.muted = audible;
      if (!audible) { if (video.volume === 0) video.volume = 1; video.play().catch(() => {}); }
    }
    const toggle = event.target.closest('[data-menu-toggle]');
    if (toggle) {
      const nav = document.getElementById(toggle.getAttribute('aria-controls'));
      if (nav.classList.contains('open')) closeMenu();
      else {
        closeSearch(); menuOpener = toggle; nav.classList.add('open');
        toggle.setAttribute('aria-expanded', 'true'); document.body.classList.add('mobile-nav-open');
        const panel = nav.querySelector('[data-menu-panel]');
        panel.setAttribute('role', 'dialog'); panel.setAttribute('aria-modal', 'true'); panel.setAttribute('aria-label', toggle.getAttribute('aria-label'));
        panel.querySelector('[data-close-menu]').focus();
      }
    }
    if (event.target.closest('[data-close-menu]')) closeMenu();
    if (event.target.closest('[data-main-nav] a') && matchMedia('(max-width:749px)').matches) closeMenu(false);
    const arrow = event.target.closest('[data-scroll-target]');
    if (arrow) { const track = document.getElementById(arrow.dataset.scrollTarget); if (track) track.scrollBy({left: track.clientWidth * .8 * Number(arrow.dataset.direction), behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth'}); }
    if (!event.target.closest('[data-header]')) closeSearch();
    document.querySelectorAll('.gemstone-menu[open]').forEach(menu => { if (!menu.contains(event.target)) menu.open = false; });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') { closeSearch(); document.querySelectorAll('.gemstone-menu[open]').forEach(menu => menu.open = false); closeMenu(); }
    const panel = document.querySelector('[data-main-nav].open [data-menu-panel]');
    if (event.key === 'Tab' && panel && matchMedia('(max-width:749px)').matches) {
      const items = [...panel.querySelectorAll('button, a[href], summary')].filter(node => !node.disabled && node.getClientRects().length);
      const first = items[0], last = items[items.length - 1];
      if (event.shiftKey && (document.activeElement === first || !items.includes(document.activeElement))) { event.preventDefault(); last?.focus(); }
      else if (!event.shiftKey && (document.activeElement === last || !items.includes(document.activeElement))) { event.preventDefault(); first?.focus(); }
    }
  });
  document.addEventListener('focusout', event => { if (event.target.closest('[data-header]') && !event.relatedTarget?.closest('[data-header]')) closeSearch(); });
  const desktop = matchMedia('(min-width:750px)'); desktop.addEventListener('change', () => { closeMenu(false); document.querySelectorAll('[data-footer-links]').forEach(d => d.open = desktop.matches); });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', event => { if (event.target.querySelector('[data-search-content]')) { const panel = document.querySelector('[data-search-panel]'); if (panel) panel.hidden = false; } });
  init();
})();
